import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [
  
 {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'collapsible',
  icon: 'home',
  role: ['IdentitySuperAdmin', 'IdentityAdmin'],
  children: [
    {
      id: 'identity-analytics',
      title: 'User Analytics',
      type: 'item',
      icon: 'circle',
      url: 'dashboard/identity-analytics'
    }
  ]
},
  // {
  //   id: 'home',
  //   title: 'Home',
  //   type: 'item',
  //   icon: 'home',
  //   role: [],
  //   url: 'home'
  // },
 {
  id: 'identity-dashboard',
  title: 'Users',
  type: 'item',
  icon: 'users',
  role: ['IdentitySuperAdmin', 'IdentityAdmin'],
  url: 'identity/identity-dashboard'
},
{
  id: 'hr-dashboard',
  title: 'Users',
  type: 'item',
  icon: 'users',
  role: ['IdentityModerator'],
  url: 'identity-HR/hr-dashboard'
},
{
  id: 'identity-roles',
  title: 'Roles',
  type: 'item',
  icon: 'edit',
  role: ['IdentitySuperAdmin'],
  url: 'identity/identity-roles'
},
{
  id: 'identity-branch',
  title: 'Codes',
  type: 'item',
  icon: 'map-pin',
  role: ['IdentitySuperAdmin'],
  url: 'identity/identity-branch'
},
{
  id: 'application',
  title: 'Application',
  type: 'item',
  icon: 'grid',
  role: ['IdentitySuperAdmin'],
  url: 'identity/application'
},


  
]
